var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 175C58.5774 175 25 141.423 25 100C25 58.5774 58.5774 25 100 25C141.423 25 175 58.5774 175 100C175 141.423 141.423 175 100 175Z",
    fill: "url(#paint0_linear_26801_1473)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4435 126.065C112.821 126.065 133.391 105.454 133.391 80.0308C133.391 54.6106 112.821 34 87.4435 34C62.0665 34 41.4956 54.6106 41.4956 80.0308H87.4435V126.065Z",
    fill: "url(#paint1_linear_26801_1473)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.842 142.072H91.5507C89.3006 142.072 87.4766 143.899 87.4766 146.153V167H108.916V146.153C108.917 143.899 107.093 142.072 104.842 142.072Z",
    fill: "url(#paint2_linear_26801_1473)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3413 142.073C96.0907 142.073 94.2684 143.899 94.2684 146.153V167H87.4766V146.153C87.4766 143.899 89.3017 142.073 91.5497 142.073H98.3413Z",
    fill: "url(#paint3_linear_26801_1473)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.384 89.5344H120.093C117.843 89.5344 116.019 91.3617 116.019 93.6159V167H137.458V93.6159C137.458 91.3617 135.634 89.5344 133.384 89.5344Z",
    fill: "url(#paint4_linear_26801_1473)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.882 89.5354C124.634 89.5354 122.809 91.3612 122.809 93.6159V167H116.02V93.6156C116.02 91.361 117.843 89.5352 120.093 89.5352H126.882V89.5354Z",
    fill: "url(#paint5_linear_26801_1473)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.926 119.966H148.634C146.384 119.966 144.56 121.793 144.56 124.047V167H166V124.047C166 121.793 164.176 119.966 161.926 119.966Z",
    fill: "#D4D9E2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.425 119.966C153.174 119.966 151.352 121.792 151.352 124.046V167H144.56V124.046C144.56 121.792 146.385 119.966 148.636 119.966H155.425Z",
    fill: "#D4D9E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9479 134.575V88.5419H33C33 113.965 53.5708 134.575 78.9479 134.575Z",
    fill: "url(#paint6_linear_26801_1473)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.6059 149.893H35.7286C34.6199 149.893 33.7217 148.993 33.7217 147.883C33.7217 146.772 34.6202 145.872 35.7286 145.872H57.3217L67.2543 124.296C67.7185 123.288 68.9111 122.847 69.9174 123.312C70.924 123.777 71.3635 124.972 70.8996 125.98L60.4287 148.725C60.1006 149.437 59.3891 149.893 58.6059 149.893Z",
    fill: "url(#paint7_linear_26801_1473)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4027 141.237H35.7286C34.6199 141.237 33.7217 140.337 33.7217 139.227C33.7217 138.116 34.6202 137.216 35.7286 137.216H52.4027C53.5114 137.216 54.4097 138.116 54.4097 139.227C54.4099 140.337 53.5114 141.237 52.4027 141.237Z",
    fill: "url(#paint8_linear_26801_1473)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.535 70.4753C115.202 70.4753 114.865 70.3922 114.554 70.2176C113.588 69.6743 113.244 68.4485 113.786 67.4802L127.106 43.7028C127.461 43.0686 128.13 42.6762 128.856 42.6762H157.178C158.287 42.6762 159.185 43.5764 159.185 44.6868C159.185 45.7972 158.286 46.6974 157.178 46.6974H130.031L117.287 69.4481C116.919 70.1055 116.237 70.4753 115.535 70.4753Z",
    fill: "#BBCAF3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.179 38.6915H137.405C136.297 38.6915 135.398 37.7913 135.398 36.6809C135.398 35.5705 136.297 34.6703 137.405 34.6703H157.179C158.287 34.6703 159.186 35.5705 159.186 36.6809C159.186 37.7913 158.287 38.6915 157.179 38.6915Z",
    fill: "url(#paint9_linear_26801_1473)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161.986 81.1837H147.404C146.295 81.1837 145.397 80.2835 145.397 79.1731C145.397 78.0627 146.295 77.1625 147.404 77.1625H161.986C163.095 77.1625 163.993 78.0627 163.993 79.1731C163.993 80.2835 163.095 81.1837 161.986 81.1837Z",
    fill: "#BBCAF3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.986 89.849H147.404C146.295 89.849 145.397 88.9488 145.397 87.8384C145.397 86.728 146.295 85.8278 147.404 85.8278H161.986C163.095 85.8278 163.993 86.728 163.993 87.8384C163.993 88.9488 163.095 89.849 161.986 89.849Z",
    fill: "#BBCAF3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M161.986 98.5146H147.404C146.295 98.5146 145.397 97.6144 145.397 96.504C145.397 95.3936 146.295 94.4934 147.404 94.4934H161.986C163.095 94.4934 163.993 95.3936 163.993 96.504C163.993 97.6144 163.095 98.5146 161.986 98.5146Z",
    fill: "#BBCAF3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1473",
    x1: 25,
    y1: 36.7188,
    x2: 167.969,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1473",
    x1: 87.4435,
    y1: 34,
    x2: 87.4435,
    y2: 126.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1473",
    x1: 98.1964,
    y1: 142.072,
    x2: 98.1964,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1473",
    x1: 92.9089,
    y1: 142.073,
    x2: 92.9089,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1473",
    x1: 122.986,
    y1: 89.5344,
    x2: 97.1362,
    y2: 155.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191087,
    stopColor: "#CAD2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974166,
    stopColor: "#B9CEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1473",
    x1: 119.55,
    y1: 89.5352,
    x2: 82.7572,
    y2: 137.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191087,
    stopColor: "#CAD2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974166,
    stopColor: "#B9CEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_1473",
    x1: 38.0255,
    y1: 88.5419,
    x2: 91.2151,
    y2: 121.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_26801_1473",
    x1: 37.8082,
    y1: 123.127,
    x2: 71.9525,
    y2: 152.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_26801_1473",
    x1: 35.9844,
    y1: 137.216,
    x2: 38.9281,
    y2: 146.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_26801_1473",
    x1: 135.398,
    y1: 34.9845,
    x2: 136.786,
    y2: 42.4278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.adfe3ab19fdd264090ebeae84e21f860.svg";
export { ForwardRef as ReactComponent };